import Link from 'next/link'

/**
 * Site-wide compliance disclaimer bar.
 *
 * Clarifies that SmartCAF is a private assistance service run by
 * Smart Services S.r.l. — not an official INPS / Agenzia delle Entrate
 * portal — while highlighting the CAF CGN and Patronato FENAPI
 * authorizations.
 *
 * Rendered directly under the navbar on the home page, services catalog,
 * NASpI service landing and dashboard pages, and the caf-patronato /
 * smart-forfettario subscription pages.
 */
const ComplianceNoticeBar = () => (
  <section className='w-full border-b border-[#d7e3c4] bg-[#f7f8f3]'>
    <div className='mx-auto w-full max-w-[70.5rem] px-16 py-16 md:px-24 md:py-20 lg:px-0'>
      <div className='flex items-start gap-12'>
        <span className='mt-2 flex h-24 w-24 flex-shrink-0 items-center justify-center rounded-full bg-[#8fc045] text-white'>
          <svg
            width='13'
            height='13'
            viewBox='0 0 24 24'
            fill='none'
            stroke='currentColor'
            strokeWidth='2'
            strokeLinecap='round'
            strokeLinejoin='round'
            aria-hidden='true'
          >
            <path d='M9 12.75L11.25 15 15 9.75m-3-7.036A11.959 11.959 0 013.598 6 11.99 11.99 0 003 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285z' />
          </svg>
        </span>
        <p className="m-0 font-['Inter'] text-[13px] leading-[20px] text-[#5c6570] md:text-[14px] md:leading-[22px]">
          Questo sito è gestito da{' '}
          <Link
            href='https://www.smartcaf.it/'
            className='font-semibold text-[#739c35] underline underline-offset-2 transition-colors hover:text-[#8fc045]'
          >
            Smartcaf.it
          </Link>{' '}
          (Smart Services S.r.l.). Non è un portale ufficiale dell&apos;INPS o
          dell&apos;Agenzia delle Entrate. Offriamo assistenza privata per la
          compilazione e trasmissione di pratiche come la NASpI e altri servizi
          fiscali. Grazie all&apos;affiliazione con CAF CGN S.p.A. (Albo n. 73),
          siamo a tutti gli effetti un Centro di Assistenza Fiscale (CAF)
          regolarmente autorizzato e riconosciuto. Insieme alla partnership con
          il Patronato FENAPI e all&apos;accreditamento diretto presso
          l&apos;Agenzia delle Entrate, garantiamo ai cittadini un supporto
          professionale, rapido e sicuro.
        </p>
      </div>
    </div>
  </section>
)

export default ComplianceNoticeBar
